module.exports = "textarea.mat-input-element {\n  overflow-y: hidden;\n  min-height: 4em; }\n\n#tx-id {\n  text-overflow: ellipsis;\n  overflow-x: hidden; }\n"